<template>
  <div class="involvement-content" :id="chartId">
    <div class="hidden-chart-name">
      {{title}} <b>{{charDateTitle}}</b>
    </div>
    <plotly :plotlyData="plotlyData"/>
    <a href="" :id="`download${chartId}`"></a>
  </div>
</template>

<script>

  // chart
  import plotly from './charts/plotly';

  // mixins
  import involvement from "../../../../../../../../mixins/chart/involvement";
  import saveImage from "../../../../../../../../mixins/saveImage";

  // config
  import age from "../../../../../../../../config/age";

  // moment
  import moment from 'moment';

  export default {
    name: "InvolvementBody",
    props: {
      plotlyData: {
        type: Object,
        required: true
      },
      chartName: {
        type: String
      },
      saveChart: {
        type: Boolean,
        default: false
      },
      title: {
        type: String
      }
    },
    data() {
      return {
        age: age,
        chartId: "Involvement",
        format: "DD.MM.YYYY",
      }
    },
    computed: {
      chartDate() {
        return this.$store.getters.getAuditPeriod(this.chartName);
      },
      isLoaded() {
        return this.$store.getters.isAuditLoaded(this.chartName);
      },
      charDateTitle () {
        return `${moment(this.chartDate[0]).format(this.format)} - ${moment(this.chartDate[1]).format(this.format)}`;
      },
    },
    mixins: [
      involvement,
      saveImage
    ],
    components: {
      plotly
    }
  };
</script>

<style>
  @import "../../../../../../../../style/tonal.css";
  .involvement-content__chart {
    margin-bottom: 10px;
  }
</style>
